import { z } from 'zod';

export const SERVICE_TYPES = [
  'Full Stack Web Application Development',
  '.NET Application Development',
  'Single Page Application Development',
  'Azure Deployment & Resource Management',
  'Mobile App Development & Store Deployment',
  'CI/CD Pipeline & Traffic Scaling',
  'Setup, Deploy, and Scale Vibe-Coded Solutions',
  'Database Administration & Management',
  'Technical Consulting',
  'Other',
] as const;

export const CONTACT_METHODS = [
  'Email',
  'Phone',
  'SMS/Text',
  'No preference',
] as const;

export const SMS_CONSENT_TEXT = `By checking this box and submitting this form, I agree to receive text messages from Gorty's Tech, LLC regarding service requests, appointment scheduling, project updates, and customer support. Message frequency varies. Message and data rates may apply. Reply HELP for help. Reply STOP to unsubscribe. Messaging consent is optional and is not required to request services.`;

export const SMS_OPT_IN_CONSENT_TEXT = `By checking this box and submitting this form, I agree to receive text messages from Gorty's Tech, LLC regarding service requests, appointment scheduling, project updates, and customer support. Message frequency varies. Message and data rates may apply. Reply HELP for help. Reply STOP to unsubscribe.`;

export const PRIVACY_POLICY_VERSION = '1.0';
export const TERMS_VERSION = '1.0';

export const serviceRequestSchema = z.object({
  fullName: z.string().min(1, 'Full name is required'),
  companyName: z.string().optional(),
  email: z.string().email('Please enter a valid email address'),
  phone: z.string().optional(),
  serviceType: z.enum(SERVICE_TYPES, { errorMap: () => ({ message: 'Please select a service type' }) }),
  preferredContactMethod: z.enum(CONTACT_METHODS).optional(),
  message: z.string().min(10, 'Please provide more details about your request (at least 10 characters)'),
  smsConsent: z.boolean(),
  turnstileToken: z.string().min(1, 'Please complete the security verification'),
});

export const smsOptInSchema = z.object({
  fullName: z.string().optional(),
  email: z.string().email('Please enter a valid email address').optional().or(z.literal('')),
  phone: z.string().min(10, 'Please enter a valid phone number'),
  smsConsent: z.literal(true, { errorMap: () => ({ message: 'You must agree to receive SMS messages to opt in' }) }),
  turnstileToken: z.string().min(1, 'Please complete the security verification'),
});

export type ServiceRequestData = z.infer<typeof serviceRequestSchema>;
export type SmsOptInData = z.infer<typeof smsOptInSchema>;
